export const Colors = {
    black: '#000000',
    white: '#FFFFFF',
    blue: '#002FE9',
    green: '#1DDE77',
    lightGrey: '#444444',
};